var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "userinfor"
  }, [_c('div', {
    staticClass: "userimg",
    on: {
      "click": _vm.getCropData
    }
  }, [_vm.userinfor.userinfolist.headImgUrl !== null ? _c('img', {
    attrs: {
      "src": _vm.userinfor.userinfolist.headImgUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/headimg.png")
    }
  }), _c('span', [_vm._v("编辑头像")])]), _c('div', {
    staticClass: "username"
  }, [_c('p', [_c('span', [_vm._v("昵称：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nickname,
      expression: "nickname"
    }],
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm.nickname
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.nickname = $event.target.value;
      }
    }
  })]), _c('p', {
    staticClass: "birthday"
  }, [_c('span', [_vm._v("生日：")]), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择生日",
      "editable": false,
      "clearable": false,
      "disabled": _vm.userinfor.userinfolist.birthday != null
    },
    model: {
      value: _vm.birthday,
      callback: function callback($$v) {
        _vm.birthday = $$v;
      },
      expression: "birthday"
    }
  })], 1)])]), _c('div', {
    staticClass: "save",
    on: {
      "click": _vm.changeInfo
    }
  }, [_vm._v("保存")])])], 1), _c('Footer'), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "close-on-click-modal": false,
      "visible": _vm.showDialog,
      "width": "500px",
      "title": "上传头像"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showDialog = $event;
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isCropper,
      expression: "!isCropper"
    }],
    staticClass: "upload"
  }, [_c('p', [_vm._v("请上传头像")]), _c('div', [_c('span', [_vm._v("上传头像")]), _c('input', {
    ref: "clearFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadpic
    }
  })]), _c('p', [_vm._v("图片格式jpg、png、jpeg，大小不超过10MB")])]), _c('vueCropper', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCropper,
      expression: "isCropper"
    }],
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "outputType": _vm.option.outputType,
      "info": _vm.option.info,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight,
      "fixedBox": _vm.option.fixedBox
    }
  }), _c('div', {
    staticClass: "cropperbtn"
  }, [!_vm.isCropper ? _c('span', {
    on: {
      "click": _vm.cancelCropper
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm.isCropper ? _c('span', {
    staticClass: "active",
    on: {
      "click": _vm.confirmPic
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm.isCropper ? _c('span', {
    on: {
      "click": _vm.reupload
    }
  }, [_vm._v("重新上传")]) : _vm._e()])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };